import { render, staticRenderFns } from "./PersonalMemberDetail.vue?vue&type=template&id=b890a5ee&scoped=true&"
import script from "./PersonalMemberDetail.vue?vue&type=script&lang=js&"
export * from "./PersonalMemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMemberDetail.vue?vue&type=style&index=0&id=b890a5ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b890a5ee",
  null
  
)

export default component.exports